import { userLogRepo } from '../repo';

export const userLogService = {
    async getAll(params = {}) {
        try {
            return await userLogRepo.getAll(params);
        } catch (error) {
            throw this.handleError(error);
        }
    },

    async getStats(params = {}) {
        try {
            return await userLogRepo.getStats(params);
        } catch (error) {
            throw this.handleError(error);
        }
    },

    async getByUser(username, params = {}) {
        if (!username) {
            throw new Error('Username is required');
        }
        try {
            return await userLogRepo.getByUser(username, params);
        } catch (error) {
            throw this.handleError(error);
        }
    },

    async getById(userlogId) {
        if (!userlogId) {
            throw new Error('User log ID is required');
        }
        try {
            return await userLogRepo.getById(userlogId);
        } catch (error) {
            throw this.handleError(error);
        }
    },

    handleError(error) {
        console.error('UserLogService Error:', error);
        return error.response?.data || error;
    },
};